import { render, staticRenderFns } from "./AccountParams.vue?vue&type=template&id=deb20a3c&scoped=true&"
import script from "./AccountParams.vue?vue&type=script&lang=js&"
export * from "./AccountParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb20a3c",
  null
  
)

export default component.exports